import { ActionTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { DaturaHistoryState } from './types';

const actions: ActionTree<DaturaHistoryState, RootState> = {
  ...subscribableStore.actions,
};

export default actions;
